const investmentFundOperationsLang = {
	title_capital_calls: {
		tag: 'investment.fund_operations.title_capital_calls',
		fr: 'Appels de fonds',
		en: 'Capital calls',
	},
	title_cash_flows: {
		tag: 'investment.fund_operations.title_cash_flows',
		fr: 'Flux financiers',
		en: 'Cash flows',
	},
	title_distributions: {
		tag: 'investment.fund_operations.title_distributions',
		fr: 'Distributions',
		en: 'Distributions',
	},
	title_share_values: {
		tag: 'investment.fund_operations.title_share_values',
		fr: 'Valeur de réalisation',
		en: 'Share values',
	},
	column_date: {
		tag: 'investment.fund_operations.column_date',
		fr: 'Date',
		en: 'Date',
	},
	column_value_per_share: {
		tag: 'investment.fund_operations.column_value_per_share',
		fr: 'Valeur de par action',
		en: 'Value per share',
	},
	column_your_distribution: {
		tag: 'investment.fund_operations.column_your_distribution',
		fr: 'Votre répartition',
		en: 'Your distribution',
	},
	column_call_id: {
		tag: 'investment.fund_operations.column_call_id',
		fr: "Identifiant de l'appel",
		en: 'Call ID',
	},
	column_amount: {
		tag: 'investment.fund_operations.column_amount',
		fr: 'Montant',
		en: 'Amount',
	},
	column_nominal_price: {
		tag: 'investment.fund_operations.column_nominal_price',
		fr: 'Valeur nominale',
		en: 'Nominal price',
	},
	column_nav_per_share: {
		tag: 'investment.fund_operations.column_nav_per_share',
		fr: 'VL',
		en: 'NAV/share',
	},
	column_total_nav: {
		tag: 'investment.fund_operations.column_total_nav',
		fr: 'NAV',
		en: 'Total NAV',
	},
	column_nb_of_shares: {
		tag: 'investment.fund_operations.column_nb_of_shares',
		fr: 'Nombre de parts',
		en: 'Nb of shares',
	},
	column_total_number_of_fund_shares: {
		tag: 'investment.fund_operations.column_total_number_of_fund_shares',
		fr: 'Nombre de parts total du fonds',
		en: 'Total number of fund shares',
	},

	graph_legend_cumulated_cashflows: {
		tag: 'investment.fund_operations.graph_legend_cumulated_cashflows',
		fr: 'Cashflows cumulés',
		en: 'Cumulated cashflows',
	},
	graph_legend_dry_powder: {
		tag: 'investment.fund_operations.graph_legend_dry_powder',
		fr: 'Reste à appeler',
		en: 'Uncalled capital',
	},
	graph_legend_cumulated_cash_inflows: {
		tag: 'investment.fund_operations.graph_legend_cumulated_cash_inflows',
		fr: 'Distributions cumulées',
		en: 'Cumulated distributions',
	},
	graph_legend_cumulated_cash_outflows: {
		tag: 'investment.fund_operations.graph_legend_cumulated_cash_outflows',
		fr: 'Appels de fonds cumulés',
		en: 'Total capital calls',
	},
};

export default investmentFundOperationsLang;
